<template>
    <a-locale-provider :locale="locale">
        <div id="app" style="    overflow-y: auto;">
            <component :is="currentContainer"></component>
        </div>
    </a-locale-provider>
</template>

<script>
    import zhCN from 'ant-design-vue/lib/locale-provider/zh_CN';
    import LayoutContainer from './layout/LayoutContainer.vue';
    import LoginView from './views/LoginView/LoginView.vue';

    export default {
        name: 'App',

        components: { LayoutContainer, LoginView },

        data() {
            return {
                locale: zhCN,
            };
        },

        computed: {
            currentContainer() {
                const { name } = this.$route;
                if (['LoginView'].includes(name)) return name;
                return 'LayoutContainer';
            },
        },
    };
</script>
